module.exports = __webpack_public_path__ + "img/presentation.f7582000.png";